exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading {\n  transition: opacity .2s;\n  background: rgba(0, 0, 0, .2);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/defaults/preloader/preloader.component.css
// module id = ../../../../../angular/app/components/defaults/preloader/preloader.component.css
// module chunks = 1